import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteData,
  deleteVoter,
  edit,
  exportTable,
  fetchData,
  fetchVoters,
  moveVoter,
} from "../../features/myListSlice/myListApi";
import {
  toggleAllRows,
  moveToPage,
  updateFilters,
  setPerPage,
  toggleColumn,
  resetFilters,
  toggleTemporaryData,
  setSort,
  toggleSelectRow,
  setColumns,
  replaceVoter,
  updateListNames,
  changeActiveListName,
} from "../../features/myListSlice/myListSlice";
import useMemory from "../../hooks/useMemory";
import Table from "../../components/table/Table";
import InCompleteRowSearchResult from "./InCompleteRowSearchResult";
import AddVotersModal from "./AddVotersModal";
import TableButton from "../../components/table/TableButton";
import MyListSteps from "../../components/steps/MyListSteps";
import ConfirmDeleteData from "../../components/ConfirmDeleteData";
import Lists from "./Lists";
import Model from "../../components/ui/Model";
import Loading from "../../components/Loading";
import EditModal from "../../components/ui/Model";
import { addList as addListApi } from "../../features/myListSlice/myListApi";
import { toast } from "react-toastify";
import EditPhoneNumberList from "../../components/EditPhoneNumberList";

const MyListTable = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isShowingTutorial, setIsShowingTutorial] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [isEditPhoneNumberModel,setIsEditPhoneNumber] = useState(false);
  // const [isShowingDeleteDataModal, setIsShowingDeleteDataModal] =
  //   useState(false);
  const [isModelShow, setIsModelShow] = useState(false);
  const [isMultipleVoterDelete, setIsMultipleVoterDelete] = useState(false);
  const [modelBtnSpinner, setmodelBtnSpinner] = useState(false);
  const [selectedDeleteVoterId, setSelectedDeleteVoterId] = useState('');
  const [isNewListModalOpen, setIsNewListModalOpen] = useState(false);
  const [newListName, setNewListName] = useState("");
  const state = useSelector((state) => state.myList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("my-list-data"));
    const storedListNames = JSON.parse(localStorage.getItem("listNames"));
    const page = searchParams.get("page");

    console.log('Initial Load - Data from localStorage:', data);
    console.log('Initial Load - Stored List Names:', storedListNames);
    console.log('Initial Load - Current State:', state);

    // If no page parameter, set it to 1
    if (!page) {
      setSearchParams({ page: 1 });
    }

    // Extract unique list names from data if they exist
    let availableListNames = [];
    if (data && Array.isArray(data.data)) {
      availableListNames = [...new Set(data.data.map(item => item.list_name))];
      console.log('Available list names from data:', availableListNames);
    }

    // Combine stored list names with available list names
    const allListNames = [...new Set([
      ...(Array.isArray(storedListNames) ? storedListNames : []),
      ...availableListNames
    ])];

    if (allListNames.length > 0) {
      console.log('Setting list names:', allListNames);
      dispatch(updateListNames(allListNames));
      if (!state.activeListName || !allListNames.includes(state.activeListName)) {
        console.log('Setting active list name to:', allListNames[0]);
        dispatch(changeActiveListName(allListNames[0]));
      }
    } else {
      console.log('No list names found, creating default');
      const defaultList = 'My List';
      dispatch(updateListNames([defaultList]));
      dispatch(changeActiveListName(defaultList));
      localStorage.setItem('listNames', JSON.stringify([defaultList]));
    }

    // Then fetch data
    dispatch(fetchData({ navigate }));

    return () => {
      dispatch(resetFilters());
    };
  }, []);

  // Force data refresh when activeListName changes
  useEffect(() => {
    console.log('Active List Name Changed:', state.activeListName);
    console.log('Current State:', state);
    if (state.activeListName) {
      dispatch(fetchData({ navigate }));
    }
  }, [state.activeListName]);

  // useMemory("my-list-memory", state, "activeListName");

  const addedTempData = useRef(false);

  const handleSort = (sorts) => {
    dispatch(setSort(sorts));
  };

  const handleChangePage = (toPage) => {
    dispatch(moveToPage(toPage));
  };

  const handleFilters = (key, value) => dispatch(updateFilters([key, value]));

  const handleToggleColumn = (key) => dispatch(toggleColumn(key));

  const handleResetFilters = () => dispatch(resetFilters());

  const handleChangePerPage = (perPage) => dispatch(setPerPage(perPage));

  const handleToggleSelectRow = (row) => {
    dispatch(toggleSelectRow({ id: row.id }));
  };

  const handleSelectAllRows = () => dispatch(toggleAllRows());

  const handleStartTutorial = () => {
    setIsShowingTutorial(true);
    if (state.data.length === 0) {
      addedTempData.current = true;
      dispatch(toggleTemporaryData());
    }
  };

  const handleReorder = (columns) => {
    const prevMemory = JSON.parse(localStorage.getItem("my-list-memory"));

    localStorage.setItem(
      "my-list-memory",
      JSON.stringify({ ...prevMemory, columns })
    );

    dispatch(setColumns(columns));
  };

  const handleDeleteModel = async () => {
    try {
      setmodelBtnSpinner(true);
      if (isMultipleVoterDelete) {
        await dispatch(deleteVoter({ navigate, id: '', isSingle: false }))
        setmodelBtnSpinner(false);
        setIsModelShow(false);
      } else {
        setIsModelShow(false);
        await dispatch(deleteVoter({ navigate, id: selectedDeleteVoterId, isSingle: true }))
        setmodelBtnSpinner(false);
        setSelectedDeleteVoterId('')
      }
    } catch (error) {
      console.error(error);
      setmodelBtnSpinner(true);
    }
  }

  const deleteSelectedRows = () => {
    setIsMultipleVoterDelete(true);
    setIsModelShow(true);
  }

  const removeSelctedVoter = (id) => {
    setIsMultipleVoterDelete(false);
    setIsModelShow(true);
    setSelectedDeleteVoterId(id)
  }

  const handleEdit = async (row, col, value) => {
    const response = await dispatch(
      edit({
        navigate,
        email: row.email,
        id: row.id,
        attribute: col.key,
        value,
      })
    );

    if (response.type.includes("fulfilled")) {
      dispatch(
        replaceVoter({
          oldVoterId: row.id,
          newVoter: { ...row, [col.key]: value },
        })
      );
    }
  };
  const handleClick = (id,from_list,to_list) => {
    setIsSpinner(true);
    dispatch(
      moveVoter({
        navigate,
        id,
        from_list,
        to_list
      })
    ).then((res) => {
      setIsSpinner(false);
    }).catch(() => {
      setIsSpinner(false);
    })
  }

  const handleAddNewList = async () => {
    if (!newListName.trim()) {
      toast.error("Please enter a list name");
      return;
    }

    if (state.listNames.includes(newListName.trim())) {
      toast.error("A list with this name already exists");
      return;
    }

    try {
      const result = await dispatch(addListApi({ navigate, newListName: newListName.trim() })).unwrap();
      
      if (result?.listNames) {
        dispatch(updateListNames(result.listNames));
        localStorage.setItem("listNames", JSON.stringify(result.listNames));
        dispatch(changeActiveListName(newListName.trim()));
        setNewListName("");
        setIsNewListModalOpen(false);
        toast.success("List created successfully!", { autoClose: 3000 });
      }
    } catch (error) {
      console.error('Error adding list:', error);
      toast.error(error.message || "Failed to add list");
    }
  };

  return (
    <>
      <MyListSteps
        enabled={isShowingTutorial}
        onExit={() => {
          setIsShowingTutorial(false);
          if (addedTempData.current) dispatch(toggleTemporaryData());
          addedTempData.current = false;
        }}
      />

      {state.fetchedVoters && <InCompleteRowSearchResult />}

      {isImportModalOpen && (
        <AddVotersModal close={() => setIsImportModalOpen(false)} />
      )}

      {isEditPhoneNumberModel && (
        <EditPhoneNumberList close={()=> setIsEditPhoneNumber(false)}/>
      )}

      {/* {isShowingDeleteDataModal && (
        <ConfirmDeleteData
          close={() => setIsShowingDeleteDataModal(false)}
          state={state.status.deleteData}
          onDelete={() => dispatch(deleteData({ navigate }))}
        />
      )} */}

      
      {isModelShow && (
        <Model
          onCancel={() => setIsModelShow(false)}
          onConfirm={() => handleDeleteModel()}
          confirmBtnText={'Confirm'}
          cancelBtnText={'Cancel'}
          modelTitle={`Delete Selected ${isMultipleVoterDelete ? 'voters' : 'Voter'}`}
          btnState={modelBtnSpinner}
        >
          <div>
            <p className="text-[#727272]">
              {`Please confirm that you want to delete selected ${isMultipleVoterDelete ? 'voters' : 'Voter'}.`}
            </p>
          </div>
        </Model>
      )}

      {isNewListModalOpen && (
        <Model
          onCancel={() => {
            setIsNewListModalOpen(false);
            setNewListName("");
          }}
          onConfirm={handleAddNewList}
          confirmBtnText="Save"
          cancelBtnText="Close"
          modelTitle="Add New List"
          btnState={state.status.addList === "loading"}
        >
          <div className="flex flex-col gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                List Name
              </label>
              <input
                type="text"
                value={newListName}
                onChange={(e) => setNewListName(e.target.value)}
                placeholder="Enter list name"
                className="w-full rounded-md h-12 border px-2 text-[15px] focus-visible:outline-cherry focus-visible:outline-2 focus-visible:outline-double"
              />
            </div>
          </div>
        </Model>
      )}

      {isSpinner ? <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"><Loading /></div> : null}
      <Table
        state={{
          ...state,
          data: state.data.slice(
            (state.page - 1) * state.perPage,
            state.page * state.perPage
          ),
        }}
        isEdit={true}
        onSortChange={handleSort}
        onFiltersChange={handleFilters}
        onToggleColumn={handleToggleColumn}
        onResetFilters={handleResetFilters}
        onChangePage={handleChangePage}
        onChangePerPage={handleChangePerPage}
        onToggleSelectRow={handleToggleSelectRow}
        onSelectAllRows={handleSelectAllRows}
        onStartTutorial={handleStartTutorial}
        onReorder={handleReorder}
        onEdit={handleEdit}
        removeSelctedVoter={removeSelctedVoter}
        tableName={'myList'}
        moveVoter={(id,from_list,to_list) => handleClick(id,from_list,to_list)}
        isListTableName="mylistTable"
        totalItems={state.data.length}
        emptyPlaceholder={(onResetFilters) => (
          <div className="w-full text-center pb-[20px]">
            <p className="text-xl font-medium">No records found</p>

            {state.columns.some((c) => c.filter.value) && (
              <div className="md-lg:absolute md-lg:bottom-0">
                <TableButton onClick={onResetFilters} icon="/import.svg">
                  Reset
                </TableButton>
              </div>
            )}
          </div>
        )}
        tableActions={[
          {
            label: "Delete Rows",
            type: "danger",
            onClick: () => deleteSelectedRows(),
            btnDisable: state.selectedRows.length === 0,
          },
          {
            label: "Update Records",
            onClick: () => setIsEditPhoneNumber(true),
            icon: "/edit.svg",
          },
          {
            label: "Download & Print List",
            state: state.status.export,
            onClick: () => dispatch(exportTable({ navigate })),
          },
          {
            label: "Add New List",
            onClick: () => setIsNewListModalOpen(true),
          },
          {
            label: "List",
            component: Lists,
          },
        ]}
        rowActions={{
          isDropdown: true,
          triggers: [state.status.actions],
          state: state.status.actions,
          options: [
            {
              label: "Find Voter ID",
              onClick: (row) => dispatch(fetchVoters({ navigate, row })),
              condition: (row) =>
                row.voter_id === "missing" && state.selectedRows.length < 2,
            },
            {
              label: "MOVE to Another List",
              menu: {
                state: state.status.moveVoter,
                options: (Array.isArray(state.listNames) ? state.listNames : [])
                  .filter((listName) => listName !== state.activeListName)
                  .map((listName) => ({
                    label: listName,
                    onClick: (row) => {
                      dispatch(
                        moveVoter({
                          navigate,
                          id: row.id,
                          from_list: state.activeListName,
                          to_list: listName,
                        })
                      );
                    },
                  })),
              },
            },
            {
              label:
                'DELETE VOTER',
              type: "danger",
              onClick: (row) => removeSelctedVoter(row.id),
            },
          ],
        }}
      ></Table>
    </>
  );
};

export default MyListTable;
